;(function (window, document) {

	'use strict'

	function removeAjaxFromNotPurchasable() {
		var elements = document.querySelectorAll('.not-purchasable .ajax_add_to_cart');

		[].forEach.call(elements, function(el) {
			el.classList.remove("ajax_add_to_cart");
		});

	}

	// Start removing classes when the page is ready.
	window.addEventListener('DOMContentLoaded', () => {
		removeAjaxFromNotPurchasable();
	})

})(window, document)